<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { BaseSelect } from "@/components";

export default {
  name: "Filters",
  components: {
    BaseSelect,
  },
  data() {
    return {
      applications: [],
      status: [],
      platform: [],
      selectedStatus: "",
      selectedApplication: "",
      selectedPlatform: "",
    };
  },
  computed: {
    ...mapGetters(["getFilterList", "getFilterData", "getRecoFilter"]),
  },
  methods: {
    ...mapActions(["fillFilter", "getRecommendedAllPackageList"]),
    ...mapMutations(["setRecommendedFilter"]),
    getFilter() {
      this.fillFilter().then((res) => {
        if (res.data) {
          const applicationsList = this.getFilterList.filter(
            (o) => o.name === "Applications"
          );
          if (applicationsList.length > 0) {
            this.applications = applicationsList[0].values;
          }

          const statusList = this.getFilterList.filter(
            (o) => o.name === "RecommendationStatus"
          );

          if (statusList.length > 0) {
            this.status = statusList[0].values;
          }

          const platformList = this.getFilterList.filter(
            (o) => o.name === "Platforms"
          );

          if (platformList.length > 0) {
            this.platform = platformList[0].values;
          }
        }
      });
    },
    changeStatus(value) {
      this.selectedStatus = value?.code.toString();
      this.applyFilters();
    },
    changeApplication(value) {
      this.selectedApplication = value?.code.toString();
      this.applyFilters();
    },
    changePlatform(value) {
      this.selectedPlatform = value?.code.toString();
      this.applyFilters();
    },

    applyFilters() {
      const filters = {
        page: 1,
        size: 100,
        filter: { Status: "2", isOrderShown: true },
      };
      if (this.selectedStatus !== "" && this.selectedStatus != undefined) {
        filters.filter.Status = this.selectedStatus;
      }
      if (this.selectedApplication !== "") {
        if (
          filters.filter.Status == null ||
          filters.filter.Status == undefined
        ) {
          filters.filter.Status = "2";
        }
        filters.filter.Applications = this.selectedApplication;
      }
      if (this.selectedPlatform !== "") {
        if (
          filters.filter.Status == null ||
          filters.filter.Status == undefined
        ) {
          filters.filter.Status = "2";
        }
        filters.filter.Platforms = this.selectedPlatform;
      }
      if (
        this.selectedApplication != undefined ||
        this.selectedPlatform != undefined
      ) {
        filters.filter.isOrderShown = false;
      }
      this.setRecommendedFilter(filters);
      this.getRecommendedAllPackageList();
    },
  },
  mounted() {
    if (
      this.applications.length <= 0 &&
      this.status.length <= 0 &&
      this.platform.length <= 0
    ) {
      delete this.getRecoFilter.Status;
      delete this.getRecoFilter.Applications;
      delete this.getRecoFilter.Platforms;
      this.setRecommendedFilter({
        filter: { Status: "2", isOrderShown: true },
      });
    }
    this.getFilter();
  },
};
</script>
<template>
  <div class="filter">
    <BaseSelect
      fieldLabel="Paket Durumu Seç"
      placeholder="Paket Durumu Seç"
      :options="status"
      id="filter"
      @change="changeStatus"
      :clearable="true"
    />
    <BaseSelect
      fieldLabel="İşlem Platformu"
      placeholder="İşlem Platformu Seç"
      :options="applications"
      id="vendor"
      @change="changeApplication"
      :clearable="true"
    />
    <BaseSelect
      fieldLabel="İşlem Yeri"
      placeholder="İşlem Yeri Seç"
      :options="platform"
      id="platform"
      @change="changePlatform"
      :clearable="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.filter {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    justify-content: center;
  }
}
.form-group:not(:last-child) {
  margin-right: 1px;
}
.form-control-label {
  font-size: 12px;
  color: var(--grayscale-70);
}
</style>
<style lang="scss">
.filter {
  .form-control-label {
    font-size: 12px;
    color: var(--grayscale-70);
    position: relative;
    padding: 0 7px;
    margin-left: 10px;
    z-index: 2;
    top: 10px;
    background: -webkit-linear-gradient(top, #f3f3f4 50%, #ffffff 50%);
  }
}
</style>
